// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

.align-bottom {
  bottom: 0;
  position: fixed;
}

.action-bar-card {
  bottom: 1px;
  position: sticky;
  z-index: 1;
  background-color: #FFFFFF;
  text-align: center;
  padding: 0;
}
.action-bar-card p {
  margin: 0;
  padding: 0;
}

.action-button {
  height: 80px;
  margin: 15px;
}

.action-button-label {
  font-size: 18px;
  line-height: 31px;
}

.action-button-subtext {
  line-height: 24px;
}

.white-text {
  color: white;
}

.black-text {
  color: black;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./src/app/shared/survey/components/workflow-bar/student-survey-workflow-bar/student-survey-workflow-bar.component.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACmBI;EACE,yJAAA;ACtCR;;ADqCM;EACE,0JAAA;AClCR;;ADiCM;EACE,0JAAA;AC9BR;;AD6BM;EACE,0JAAA;AC1BR;;ADyBM;EACE,2JAAA;ACtBR;;ADqBM;EACE,2JAAA;AClBR;;ADiBM;EACE,4JAAA;ACdR;;ADaM;EACE,4JAAA;ACVR;;ADSM;EACE,4JAAA;ACNR;;ADKM;EACE,4JAAA;ACFR;;ADCM;EACE,8JAAA;ACER;;ADHM;EACE,8JAAA;ACMR;;ADPM;EACE,8JAAA;ACUR;;ADXM;EACE,8JAAA;ACcR;;ADfM;EACE,8JAAA;ACkBR;;ADnBM;EACE,8JAAA;ACsBR;;ADvBM;EACE,+JAAA;AC0BR;;AD3BM;EACE,+JAAA;AC8BR;;AD/BM;EACE,+JAAA;ACkCR;;ADnCM;EACE,+JAAA;ACsCR;;ADvCM;EACE,gKAAA;AC0CR;;AD3CM;EACE,gKAAA;AC8CR;;AD/CM;EACE,gKAAA;ACkDR;;ADnDM;EACE,gKAAA;ACsDR;;ADvDM;EACE,gKAAA;AC0DR;;ADvFE;EACE,6BAAA;AC0FJ;;ADnFI;EACE,yFAAA;EACA,uEAAA;ACsFN;;AA5GA;EACE,SAAA;EACA,eAAA;AA+GF;;AA5GA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;AA+GF;AA7GE;EACE,SAAA;EACA,UAAA;AA+GJ;;AA3GA;EACE,YAAA;EACA,YAAA;AA8GF;;AA3GA;EACE,eAAA;EACA,iBAAA;AA8GF;;AA3GA;EACE,iBAAA;AA8GF;;AA3GA;EACE,YAAA;AA8GF;;AA3GA;EACE,YAAA;AA8GF","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use \"sass:map\";\r\n@use \"./src/styles/abstracts/mixins\" as mix;\r\n@use \"./src/styles/theme/theme-variables\" as theme;\r\n\r\n.align-bottom {\r\n  bottom: 0;\r\n  position: fixed;\r\n}\r\n\r\n.action-bar-card {\r\n  bottom: 1px;\r\n  position: sticky;\r\n  z-index: 1;\r\n  background-color: #FFFFFF;\r\n  text-align: center;\r\n  padding: 0;\r\n\r\n  p {\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.action-button {\r\n  height: 80px;\r\n  margin: 15px;\r\n}\r\n\r\n.action-button-label {\r\n  font-size: 18px;\r\n  line-height: 31px;\r\n}\r\n\r\n.action-button-subtext {\r\n  line-height: 24px;\r\n}\r\n\r\n.white-text {\r\n  color: white;\r\n}\r\n\r\n.black-text {\r\n  color: black;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
